import { ICoupon, ICouponApplied } from 'types/coupon';
import { CouponGoodsItem } from 'types/cart';
import { computeCouponDiscount } from 'services/coupon/compute-coupon-discount';
import { canUseCouponInTime } from 'services/coupon/get-coupon-list';

export const computeShopCouponBaseAmount = (
    goodsList: CouponGoodsItem[],
    coupon?: ICouponApplied
) => {
    let baseAmount = 0;
    const list: CouponGoodsItem[] = [];
    const newList: CouponGoodsItem[] = [];
    let discount = 0;

    // eslint-disable-next-line complexity
    goodsList.forEach((goods) => {
        const price = goods.price * goods.amount;
        goods.SCReducer = 0;
        const goodsNew = { ...goods };
        newList.push(goodsNew);
        if (coupon) {
            if (price <= 0) {
                // 价格小于0不参与接下来的优惠计算
            } else if (goods.isLimit) {
                // 限制区域下单
            } else if (goods.fullDiscount && !goods.fullDiscount.canUseCoupon && goods.FDReducer) {
                // 满减商品不支持使用优惠券
            } else if (goods.campaign && !goods.campaign.canUseCoupon && !goods.campaign.isPre) {
                // 活动商品不支持使用优惠券
            } else if (goods.supplyId && goods.supplyId !== 0 && goods.shopId !== 'fUCPXX') {
                // 分销商品不支持使用优惠券
            } else if (!canUseCouponInTime(coupon)) {
                // 优惠券不在使用时间内
            } else {
                if (coupon.type.toString().split('')[0] === '2') {
                    baseAmount += price;
                    list.push(goodsNew);
                } else if (
                    coupon.typeDetail &&
                    coupon.typeDetail.split(',').indexOf(goods.id) >= 0
                ) {
                    baseAmount += price;
                    list.push(goodsNew);
                }
            }
        }
    });

    if (baseAmount > 0) {
        const canUseLen = list.length;
        let hasComputedDis = 0;
        discount = computeCouponDiscount(coupon, baseAmount);
        list.sort(
            (item1, item2) => item1.price * item1.amount - item2.price * item2.amount
        ).forEach((goods, index) => {
            if (index === canUseLen - 1) {
                goods.SCReducer = discount - hasComputedDis;
            } else {
                const price = goods.price * goods.amount;
                goods.SCReducer = Math.floor((price / baseAmount) * discount);
                hasComputedDis += goods.SCReducer;
            }
        });
    }

    if (baseAmount <= 1) {
        discount = 0;
    }

    return {
        list: [...newList],
        base: baseAmount,
        discount
    };
};

export const computePlatformCouponBaseAmount = (
    goodsList: CouponGoodsItem[],
    coupon?: ICouponApplied
) => {
    let baseAmount = 0;
    const list: CouponGoodsItem[] = [];
    const newList: CouponGoodsItem[] = [];
    let discount = 0;

    goodsList.forEach((goods) => {
        // const reducerPrice = goods.price * goods.amount - (goods.FDReducer || 0) - (goods.SCReducer || 0); // 双十一改成平行优惠计算
        const price = goods.price * goods.amount - (goods.FDReducer || 0);
        goods.FCReducer = 0;
        const goodsNew = { ...goods };
        newList.push(goodsNew);
        if (coupon) {
            if (price <= 0) {
                // 价格小于0不参与接下来的优惠计算
            } else if (goods.isLimit) {
                // 限制区域下单
            } else if (goods.campaign && !goods.campaign.canUseCoupon && !goods.campaign.isPre) {
                // 活动商品不支持使用优惠券
            } else if (!canUseCouponInTime(coupon)) {
                // 优惠券不在使用时间内
            } else if (goods.payType === 0) {
                // 平台券不支持货到付款商品
            } else {
                // 全平台
                if (coupon.platformSubType === 0) {
                    baseAmount += price;
                    list.push(goodsNew);
                }

                // 指定商家
                if (
                    coupon.platformSubType === 1 &&
                    coupon.typeDetail &&
                    coupon.typeDetail.split(',').indexOf(goods.shopId) >= 0
                ) {
                    baseAmount += price;
                    list.push(goodsNew);
                }

                // 指定商品
                if (
                    coupon.platformSubType === 2 &&
                    (coupon.productIds || []).indexOf(goods.id) >= 0
                ) {
                    // @ts-ignore
                    if (window['is_cart_page']) {
                        return;
                    }

                    baseAmount += price;
                    list.push(goodsNew);
                }
            }
        }
    });

    if (baseAmount > 0) {
        const canUseLen = list.length;
        let hasComputedDis = 0;
        discount = computeCouponDiscount(coupon, baseAmount);
        /* why sort?
         *  为了防止900元和1分的商品平分1分钱优惠券时
         *  ，先计算900元的分到0分，再计算1分钱分到1分，
         *  最后算实际值时优惠券没有优惠😢
         * */
        list.sort(
            (item1, item2) => item1.price * item1.amount - item2.price * item2.amount
        ).forEach((goods, index) => {
            if (index === canUseLen - 1) {
                goods.FCReducer = discount - hasComputedDis;
            } else {
                const price = goods.price * goods.amount;
                goods.FCReducer = Math.floor((price / baseAmount) * discount);
                hasComputedDis += goods.FCReducer;
            }
        });
    }
    if (baseAmount < 0) {
        discount = 0;
    }

    return {
        list: [...newList],
        base: baseAmount,
        discount
    };
};
